import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  vfHeader: theme => ({
    backgroundColor: theme.colors.backgroundColorThree,
  }),
  contentContainer: {
    paddingHorizontal: 16,
    paddingVertical: 33,
  },
  header: theme => ({
    fontSize: 16,
    letterSpacing: 0.0,
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColorSix,
    marginBottom: 32,
    lineHeight: 18,
  }),
});
